import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './models/user-state.models';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUserProfile = createSelector(
  selectUserState,
  (state: UserState) => state.profile
);

export const selectUserLoading = createSelector(
  selectUserState,
  (state: UserState) => state.loading
);

export const selectUserDeletingAccount = createSelector(
  selectUserState,
  (state: UserState) => state.deletingAccount
);

export const selectUserDeletingPersonalData = createSelector(
  selectUserState,
  (state: UserState) => state.deletingPersonalData
);

export const selectUserError = createSelector(
  selectUserState,
  (state: UserState) => state.error
);

export const selectUserCacheTimestamp = createSelector(
  selectUserState,
  (state: UserState) => state.cacheTimestamp
);

// Derived selectors
export const selectIsProfileLoaded = createSelector(
  selectUserProfile,
  (profile) => profile !== null
);

export const selectUserEmail = createSelector(
  selectUserProfile,
  (profile) => profile?.email ?? null
);

export const selectUserId = createSelector(
  selectUserProfile,
  (profile) => profile?.id ?? null
);

// Cache validity selector (60 seconds)
const CACHE_DURATION = 60000;

export const selectIsCacheValid = createSelector(
  selectUserCacheTimestamp,
  (timestamp) => {
    if (!timestamp) return false;
    return (Date.now() - timestamp) < CACHE_DURATION;
  }
);
